import * as Flickity from 'flickity';

export const resizeGallery = (gallerySelector) => {
    const elements = document.querySelectorAll(gallerySelector);
    Array.prototype.forEach.call(elements, function(el) {
        const flickity = Flickity.data(el);
        flickity.resize()
    });
};
